import React, { useEffect } from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M6.167 13.5H4A1.5 1.5 0 012.5 12V8.5h3.667v5zm5.833 0H9.833v-11H13.5V12a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M6.167 13.5h3.667v-8H6.167v8z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5zm8.75 0h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25zm-8.75 0h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18.5 40.5H12A4.5 4.5 0 017.5 36V25.5h11v15zm17.5 0h-6.5v-33h11V36a4.5 4.5 0 01-4.5 4.5zm-17.5 0h11v-24h-11v24z",
    clipRule: "evenodd"
  }))
};
export var Activity = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});
Activity.displayName = "[Deprecated] Activity";